<faxe-page-layout showClock=true>
  <form [formGroup]="formGroup">

    <mat-card appearance="outlined" class="ctx-large">
      <faxe-page-title></faxe-page-title>
      <faxe-input-form #inputstart
                       label="Ryttarnummer"
                       formCtrlName="start"
                       [parentFormGroup]="formGroup"
                       (input)="onInput()"
                       [inputAutoFocus]=true
                       [requiredInput]=true
                       (keydown.enter)='onStart()'>
      </faxe-input-form>

      <button
        [disabled]="startPending"
        mat-raised-button
        color="primary"
        class="wide"
        (click)="onStart()">
        START
      </button>

    </mat-card>

    <faxe-rolling-hist-list
      [listItems]="listItems"
    ></faxe-rolling-hist-list>

  </form>
</faxe-page-layout>
